import BaseAvatarProfile from 'app/components/common/BaseAvatarProfile'
import { BaseCollapse } from 'app/components/common/BaseCollapse'
import { BaseDivider } from 'app/components/common/BaseDivider'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { FONT_WEIGHT, PADDING } from 'parkway-web-common'
import styled from 'styled-components'

export const SectionBaseWrapper = styled(SectionBase)`
  padding: ${PADDING.xl} !important;
`
export const SectionTitle = styled(BaseText)`
  font-size: 16px !important;
  font-weight: ${FONT_WEIGHT.semibold}!important;
  color: ${convertedVariables.primaryColor};
`
export const NameText = styled(BaseText)`
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.semibold}!important;
  color: ${convertedVariables.primaryColor};
`
export const SectionDescription = styled(BaseText)`
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.regular}!important;
  color: ${convertedVariables.primaryColor};
  margin-top: 8px;
`
export const ItemLabel = styled(BaseText)`
  font-size: 14px !important;
  font-weight: ${FONT_WEIGHT.regular}!important;
  color: #858c94;
`
export const ItemValue = styled(BaseText)`
  font-size: 14px !important;
  font-weight: ${FONT_WEIGHT.semibold}!important;
  color: ${convertedVariables.primaryColor};
  margin-top: 8px;
`
export const TotalText = styled(BaseText)`
  flex: 1;
  text-align: end;
  font-size: 12px !important;
  font-weight: ${FONT_WEIGHT.semibold}!important;
  color: ${convertedVariables.primaryColor};
`
export const Divider = styled(BaseDivider)`
  margin: 20px 0;
`
export const TitleContainer = styled(BaseSpace)`
  padding: 12px 20px;
  border-bottom: 1px solid #ebeef2;
`
export const CollapseWrapper = styled(BaseCollapse)`
  border: none;
  background: white;
  overflow: hidden;

  .ant-collapse-header {
  }
  .ant-collapse-item {
    border-bottom: 0px;
  }
  .ant-collapse-content {
    .ant-collapse-content-box {
      padding: 0 !important;
      border-bottom-left-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }
    margin-left: 0px !important;
    margin-right: 0px !important;
    border-top: 1px solid #f4f6f9;
  }

  .ant-collapse-header {
    align-items: center !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .ant-collapse-header[aria-expanded='true'] {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
`
export const ProfileContainer = styled.div`
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100% !important;
  border-radius: 8px;
  border: 1px solid #f4f6f9;
  background: var(--white) !important;
  padding: 12px !important;
  .job-title-class {
    font-size: 10px !important;
    font-weight: ${FONT_WEIGHT.regular}!important;
    color: ${convertedVariables.primaryColor};
  }
`
export const Profile = styled(BaseAvatarProfile)``
export const ListContainer = styled(BaseSpace)`
  padding: 20px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  background: #fcfcfd;
  max-height: 400px !important;
  overflow: auto;
  row-gap: 0;
  gap: 20px;
`
